import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import { ApplicationState } from '@/state/root.models'

import { RestApiService } from '@/services'
import { setLoadingFullAction } from '@/state/ui/global/slices/index.slices'
import { jsonToQueryString } from '@/utils'

import { listProviders } from '@/constants/providers'
import { BONUS_PROGRAMS } from './api.routes'
import ActionTypes from '../constants'

import {
  GetAllProvidersPayload,
  BonusEngineState,
  BonusProvidersResponse,
} from '../models'

const restApiService: RestApiService = Container.get(RestApiService)

export const getProvidersThunk = createAsyncThunk(
  ActionTypes.GET_ALL_PROVIDERS,
  async (payload: GetAllProvidersPayload, thunkAPI) => {
    const { hideFullLoading, ...queries } = payload

    try {
      restApiService.requestParams = {
        method: 'GET',
        endpoint: BONUS_PROGRAMS.FIND_PROVIDERS,
        queries: jsonToQueryString(queries),
      }

      const { auth } = thunkAPI.getState() as ApplicationState

      if (!hideFullLoading) {
        thunkAPI.dispatch(setLoadingFullAction(true))
      }

      const response: BonusProvidersResponse[] = await restApiService.getData(
        auth.brand.siteId.toString(),
        auth.token,
      )

      thunkAPI.dispatch(setLoadingFullAction(false))

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
      throw error
    }
  },
)

const getProvidersExtraReducer = (
  builder: ActionReducerMapBuilder<BonusEngineState>,
) => {
  builder.addCase(getProvidersThunk.pending, (state) => {
    state.isLoading = true
    state.isLoadingProviders = true
  })
  // HERE
  // builder.addCase(getProvidersThunk.fulfilled, (state, { payload }) => {
  //   state.isLoading = false

  //   const provider = payload
  //     .filter((item) => listProviders.includes(item.id))
  //     .map((item) => ({
  //       id: item.id,
  //       name: item.name,
  //     }))
  //   // console.log('provider:', provider)
  //   // console.log('Payload', payload)
  //   // console.log('listProviders', listProviders)

  //   state.providers = provider
  //   state.isLoadingProviders = false
  // })
  builder.addCase(getProvidersThunk.fulfilled, (state, { payload }) => {
    state.isLoading = false
    // const provider = payload.filter((item) =>
    //   listProviders.find((itemProvider) => itemProvider === item.id),
    // )
    state.providers = payload
    state.isLoadingProviders = false
  })
}

export default getProvidersExtraReducer
